<template>
    <div class="mt-8 flex h-auto w-full flex-col gap-4">
        <div
            v-for="(item, index) in items"
            :key="item.id"
            class="flex h-auto w-full flex-col gap-2 rounded-md border border-gray-200 p-4"
        >
            <div class="flex h-10 w-full items-center justify-end">
                <button
                    class="bg-danger-500 hover:bg-danger-600 h-auto w-auto shrink-0 rounded-md px-3 py-2 text-sm font-medium text-white"
                    @click="removeItem(index)"
                >
                    <fa icon="fa-trash-can" />
                </button>
            </div>
            <div class="flex h-auto w-full items-center gap-2">
                <TextField
                    v-model="item.label"
                    :name="`${namePrefix}_${index}_label`"
                    label="campaign_marketing_use_of_funds_item_label"
                    help="help_campaign_marketing_use_of_funds_item_label"
                    class="h-10 w-full"
                />
            </div>
            <div class="flex h-auto w-full items-center gap-4">
                <NumberField
                    v-model="item.minimum_percentage"
                    :name="`${namePrefix}_${index}_minimum_percentage`"
                    label="campaign_marketing_use_of_funds_item_minimum_percentage"
                    help="help_campaign_marketing_use_of_funds_item_minimum_percentage"
                    unit="%"
                    :min="0"
                    :max="100"
                />
                <NumberField
                    v-model="item.full_percentage"
                    :name="`${namePrefix}_${index}_full_percentage`"
                    label="campaign_marketing_use_of_funds_item_full_percentage"
                    help="help_campaign_marketing_use_of_funds_item_full_percentage"
                    unit="%"
                    :min="0"
                    :max="100"
                />
            </div>
            <div class="flex h-auto w-full items-center gap-4">
                <SelectField
                    v-model="item.minimum_badge"
                    :name="`${namePrefix}_${index}_minimum_badge`"
                    label="campaign_marketing_use_of_funds_item_minimum_badge"
                    help="help_campaign_marketing_use_of_funds_item_minimum_badge"
                    :options="mapEnumToArray(CampaignUseOfFundsBadge)"
                    :reduce="reduceEnumValue"
                />
                <SelectField
                    v-model="item.full_badge"
                    :name="`${namePrefix}_${index}_full_badge`"
                    label="campaign_marketing_use_of_funds_item_full_badge"
                    help="help_campaign_marketing_use_of_funds_item_full_badge"
                    :options="mapEnumToArray(CampaignUseOfFundsBadge)"
                    :reduce="reduceEnumValue"
                />
            </div>
        </div>
        <div class="flex h-auto w-full items-center justify-end">
            <button
                class="h-auto w-auto rounded-md bg-blue-500 px-4 py-2 text-sm font-medium text-white"
                @click="addItem"
            >
                {{ $t('campaign_marketing_use_of_funds_add_item') }}
            </button>
        </div>
    </div>
</template>

<script setup lang="ts">
import NumberField from '@src/components/NumberField.vue'
import SelectField from '@src/components/SelectField.vue'
import TextField from '@src/components/TextField.vue'
import { useEnum } from '@src/composables/common'
import { CampaignUseOfFundsBadge } from '@src/enums'
import { CampaignUseOfFundsItem } from '@src/types'
import { generateUuid } from '@src/utils/helpers'
import { useVModel } from '@vueuse/core'

const props = defineProps<{
    modelValue: CampaignUseOfFundsItem[]
    namePrefix: string
}>()

const emit = defineEmits<{
    (e: 'update:modelValue', value: CampaignUseOfFundsItem[]): void
}>()

const { mapEnumToArray, reduceEnumValue } = useEnum()

const items = useVModel(props, 'modelValue', emit)

const addItem = () => {
    items.value = [
        ...(items.value ?? []),
        {
            id: generateUuid(),
            label: '',
            minimum_percentage: null,
            full_percentage: null,
            minimum_badge: null,
            full_badge: null,
        },
    ]
}

const removeItem = (index: number) => {
    items.value?.splice(index, 1)
}
</script>
